!function(){
  "use strict";

  var timer=0;
  var observedRoot=null;
  var rootObserver=null;
  var styleText=[
    /* 01.09.2026: Produktbilder im Upcart durchgaengig mit derselben
       weichen Ecke darstellen. Der Radius sitzt sowohl am Bild als auch am
       abschneidenden Wrapper, damit er nach jedem Upcart-Neurendern bleibt. */
    ".upcart-public-component-product-tile__image-wrapper,.upcart-internal-component-product-tile__image-wrapper,.upcart-public-component-upsell-tile__image-container,.upcart-internal-component-upsell-tile__image-container{border-radius:14px!important;overflow:hidden!important;isolation:isolate!important}",
    ".upcart-public-component-product-tile__image,.upcart-internal-component-product-tile__image,.upcart-public-component-upsell-tile__image,.upcart-internal-component-upsell-tile__image{border-radius:14px!important;display:block!important}",
    /* Hochformat-Upsells werden von Upcart sonst in ein quadratisches Bild-
       Element eingepasst. Dann liegt die sichtbare scharfe Kante innerhalb
       des gerundeten Elements. Das Bild erhaelt deshalb seine echte Breite
       und wird mittig im unveraenderten 90-px-Medienplatz ausgerichtet. */
    ".upcart-public-component-upsell-tile__image-container,.upcart-internal-component-upsell-tile__image-container{display:flex!important;align-items:center!important;justify-content:center!important}",
    ".upcart-public-component-upsell-tile__image,.upcart-internal-component-upsell-tile__image{width:auto!important;height:100%!important;max-width:100%!important;object-fit:contain!important}",
    ".upcart-public-component-product-tile__subscription-upgrade-btn,.upcart-internal-component-product-tile__subscription-upgrade-btn{background:#ececec!important;color:#151013!important;border:1px solid #d3d3d3!important;box-shadow:none!important}",
    ".upcart-public-component-product-tile__subscription-upgrade-btn *,.upcart-internal-component-product-tile__subscription-upgrade-btn *{color:#151013!important}",
    "@media(hover:hover){.upcart-public-component-product-tile__subscription-upgrade-btn:hover,.upcart-internal-component-product-tile__subscription-upgrade-btn:hover{background:#e2e2e2!important;color:#151013!important}}",
    ".upcart-public-component-product-tile__subscription-upgrade-btn:focus-visible,.upcart-internal-component-product-tile__subscription-upgrade-btn:focus-visible{outline:2px solid #151013!important;outline-offset:2px!important}"
  ].join("");

  function replaceButtonText(button){
    var current=(button.textContent||"").replace(/\s+/g," ").trim();
    if(current==="Mit Abo sparen")return;
    if(!/^(Abo ausw[aä]hlen|Upgrade(?: to| auf)? .+|Abonnement ausw[aä]hlen)$/i.test(current))return;
    var leaves=Array.prototype.slice.call(button.querySelectorAll("*")).filter(function(element){
      return !element.children.length&&(element.textContent||"").trim();
    });
    if(leaves.length===1)leaves[0].textContent="Mit Abo sparen";
    else button.textContent="Mit Abo sparen";
    button.setAttribute("aria-label","Mit Abo sparen");
  }

  /* 28.08.2026, Mert: "Mach Monatsvorrat raus. Das nimmt zu viel Platz.
     Monatsvorrat tust Du bei mit Abo sparen, da wo mit Abo sparen steht.
     also nur einmal sagen."
     Shopify haengt den Namen der Verkaufsplan-Gruppe an JEDE Zeile:
     "Monatsvorrat im Abo / Alle 30 Tage liefern". In der schmalen Auswahl
     steht das Wort dann mehrfach untereinander. Es gehoert genau einmal
     hin - in die Gruppenueberschrift. */
  var GRUPPE=/^\s*Monatsvorrat(?:\s+im\s+Abo)?\s*(?:\/|\u2013|\u2014|-|\u00b7|:)\s*/i;

  function ohneGruppenname(text){
    var kurz=(text||"").replace(GRUPPE,"").trim();
    /* Bleibt nichts uebrig, war die Zeile NUR der Gruppenname - dann lieber
       den Originaltext stehen lassen als eine leere Zeile. */
    return kurz||text;
  }

  function translateSelect(select){
    select.querySelectorAll("optgroup").forEach(function(group){
      if(group.label==="Full price")group.label="Ohne Abo";
      if(group.label==="Subscription plans"||group.label==="Mit Abo sparen"){
        group.label="Mit Abo sparen \u00b7 Monatsvorrat";
      }
    });
    select.querySelectorAll("option").forEach(function(option){
      if(option.value==="otp"||option.text.trim()==="One-time purchase"){
        option.text="Einmaliger Kauf";
        option.label="Einmaliger Kauf";
        return;
      }
      var kurz=ohneGruppenname(option.text);
      if(kurz!==option.text){
        option.text=kurz;
        option.label=kurz;
      }
    });
    if(select.querySelector('option[value="otp"]'))select.setAttribute("aria-label","Kaufoption auswählen");
  }

  function apply(root){
    if(!root)return;
    if(!root.getElementById("mm-upcart-abo-v1")){
      var style=document.createElement("style");
      style.id="mm-upcart-abo-v1";
      style.textContent=styleText;
      root.appendChild(style);
    }
    root.querySelectorAll(".upcart-public-component-product-tile__subscription-upgrade-btn,.upcart-internal-component-product-tile__subscription-upgrade-btn").forEach(replaceButtonText);
    root.querySelectorAll("select").forEach(translateSelect);
  }

  function bind(){
    var host=document.getElementById("upCart");
    var root=host&&host.shadowRoot;
    if(!root){
      window.clearTimeout(timer);
      timer=window.setTimeout(bind,250);
      return;
    }
    apply(root);
    if(observedRoot===root)return;
    if(rootObserver)rootObserver.disconnect();
    observedRoot=root;
    rootObserver=new MutationObserver(function(){
      window.clearTimeout(timer);
      timer=window.setTimeout(function(){apply(root)},40);
    });
    rootObserver.observe(root,{childList:true,subtree:true});
  }

  function start(){
    bind();
    if(!window.mmUpcartAboInterval)window.mmUpcartAboInterval=window.setInterval(bind,500);
    if(document.documentElement.dataset.mmUpcartAboWatch)return;
    document.documentElement.dataset.mmUpcartAboWatch="1";
    new MutationObserver(function(){
      window.clearTimeout(timer);
      timer=window.setTimeout(bind,80);
    }).observe(document.documentElement,{childList:true,subtree:true});
  }

  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start);
  else start();
  window.addEventListener("load",bind);
}();
